<template>
    <div class="historico-importacao-list px-4">
        <div class="table-container">
            <b-table id="historico-importacao-temp" striped responsive :items="rows" :fields="headerFields">
                <template v-slot:cell(status)="{ item }">
                    <div  style="min-width: 100px">
                        <div class="status small-text" :class="getStatusClass( item.status )">
                            {{ item.status }}
                        </div>
                    </div>                    
                </template>

                <template v-slot:cell(produtos)="{ item }">
                    <div  style="min-width: 100px">
                        {{ getStringProdutos(item.produtos) }}
                    </div>                    
                </template>
                                
                <template v-slot:cell(errors)="{ item }">
                    <DynamicIcon icon="not"  v-if="item.errors" :classString="'alert-exclamation-30'"/>
                    <DynamicIcon icon="check"  v-if="!item.errors" :classString="'alert-exclamation-30'"/>
                </template>
                <template v-slot:cell(fileNameOriginal)="{ item }">
                    <b-link v-if="isAdmin" @click="downloadFile(item.id)">{{item.fileNameOriginal}}</b-link>
                    <span v-else >{{item.fileNameOriginal}}</span>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>

import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import { mapGetters } from "vuex"

let headerFields = [
    {key: 'id', label: "ID da importação", thClass: 'px-2', tdClass: 'px-2'},
    {key: 'text', label: "Empresa", thClass: 'px-2', tdClass: 'px-2'},
    {key: 'userEmail', label: 'E-mail', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'status', label: 'Status', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'tipoImportacao', label: 'Tipo Importação', thClass: 'px-2'},
    {key: 'produtos', label: 'Serviço(s)', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'dataHora', label: 'Data', thClass: 'px-2', tdClass: 'px-2'},
    //{key: 'errors', label: 'Erros'},
    {key: 'totalLinhas', label: 'Linhas', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'totalTitulares', label: 'Titulares', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'totalDependentes', label: 'Dependentes', thClass: 'px-2', tdClass: 'px-2'},
    {key: 'totalCpfUnicos', label: `Total de CPF's únicos`, thClass: 'px-2', tdClass: 'px-2'},
    // {key: 'totalImportados', label: 'Total Importado com sucesso', thClass: 'text-center', tdClass: 'px-2'},
    // {key: 'totalNaoImportados', label: 'Total Importado com erro', thClass: 'text-center', tdClass: 'text-center'},
    {key: 'fileNameOriginal', label: 'Nome do arquivo', thClass: 'px-2', tdClass: 'px-2'},
]

let columnsKeys = [
    'id',
    'text',
    'userEmail',
    'status',
    'tipoImportacao',
    'produtos',
    'dataHora',
    //'errors',
    'totalLinhas',
    'totalTitulares',
    'totalDependentes',
    'totalCpfUnicos',
    // 'totalImportados',
    // 'totalNaoImportados',
    'fileNameOriginal',
]

const _status = { 
    'Aguardando processamento' : 'alert',
    'Pre importação' : 'alert',
    'Aguardando inicialização': 'alert',
    'Em execução' : 'alert',
    'Finalizada' : 'active',
    'Cancelada': 'inative',
    'Erro durante execução': 'inative' 
}

export default {
    name: "HistoricoImportacaoList",
    components:{
        DynamicIcon
    },
    props: {
		rows: Array
	},
    data() {
        return {
            lastFilter: {},
            page: 1,
        }

    },
    computed: {
        ...mapGetters("user", ["authorities"]),
        isAdmin () {
            if ( this.authorities ) {
                return this.authorities.includes("ROLE_ADMIN")
            }   
            return false;
        },
        headerFields () {
            if(!this.isAdmin) {
                if(headerFields[0].key == "empresaId")
                    headerFields.shift();
            }
            return headerFields.filter(head => columnsKeys.includes(head.key))
        }
    },
    methods: {
        downloadFile : (importacaoId) => {
            BeneficiarioImportacaoResource.downloadFile( importacaoId )
        },
        getStatusClass( status ){
            return _status[ status ]
        },
        getStringProdutos( produtos ){
            if(!produtos) return

            return produtos.join(", ")
        }
    },
}
</script>
<style scoped lang="scss">
.table-container .table-responsive {
	font-size: small;
}
</style>